import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Scanners } from "../components/site/Scanners";
import { WhyWhatThe } from "../components/site/WhyWhatThe";
import { Pricing } from "../components/site/Pricing";
import { FAQ } from "../components/site/FAQ";
import { EmailCapture } from "../components/site/EmailCapture";
import { Support, Legal } from "../components/site/SupportLegal";
import { Footer } from "../components/site/Footer";
import { ScannerDetailProvider } from "../components/site/ScannerDetail";
import { Seo } from "../components/Seo";

export default function Landing() {
  const [planInterest, setPlanInterest] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.lenis;
    };
  }, []);

  const handlePick = (key) => {
    setPlanInterest(key);
    document.querySelector("#get")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <ScannerDetailProvider>
    <div className="App relative bg-page">
      <Seo
        title="AI Ingredient Scanner for Food & Body — WhatThe? Scan"
        description="Scan food labels, plated meals and skincare ingredients with AI. Get plain-English answers on allergens, additives and nutrition. 4 free scans on iPhone."
        path="/"
      />
      <Toaster position="top-center" richColors />
      <Nav />
      <main>
        <Hero />
        <Scanners />
        <WhyWhatThe />
        <Pricing onPick={handlePick} />
        <FAQ />
        <EmailCapture planInterest={planInterest} />
        <Support />
        <Legal />
      </main>
      <Footer />
    </div>
    </ScannerDetailProvider>
  );
}
